import { IconeConversa } from '../../components/IconesDeDocumento'
import { TEXTOS } from '../../lib/glossario'

/**
 * A conversa vazia: o convite e quatro perguntas de exemplo.
 *
 * Os exemplos ensinam o tamanho de pergunta que funciona melhor — uma pergunta, um assunto — sem um
 * parágrafo de instruções. Clicar preenche e envia: quem chega pela primeira vez vê uma resposta com
 * citação antes de precisar escrever qualquer coisa.
 *
 * @param props o que fazer ao escolher um exemplo, e se dá para perguntar agora
 * @returns as boas-vindas
 */
export function BoasVindas({ aoEscolher, desabilitada }: { aoEscolher: (pergunta: string) => void; desabilitada: boolean }) {
  const t = TEXTOS.consulta
  return (
    <div className="mx-auto max-w-2xl py-6 text-center sm:py-10">
      <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-niteroi-50 text-niteroi-700">
        <IconeConversa className="h-6 w-6" />
      </span>
      <h2 className="mt-4 text-xl font-semibold text-niteroi-700">{t.boasVindas}</h2>
      <p className="mx-auto mt-2 max-w-prose text-sm text-slate-600">{t.boasVindasAjuda}</p>
      <ul className="mt-6 grid gap-2 text-left sm:grid-cols-2">
        {t.sugestoes.map((sugestao) => (
          <li key={sugestao}>
            <button
              type="button"
              disabled={desabilitada}
              onClick={() => aoEscolher(sugestao)}
              className="h-full w-full rounded-xl bg-white px-4 py-3 text-left text-sm text-slate-700 ring-1 ring-slate-200 transition-colors hover:bg-niteroi-50 hover:text-niteroi-800 hover:ring-niteroi-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-niteroi-600 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {sugestao}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
